export const removeIsExtraField = (data) => {
    return data.map(node => {
        const newNode = {
            name: node.name,
            children: node.childrenNodes.length > 0 ? removeIsExtraField(node.childrenNodes) : []
        };
        return newNode;
    });
};
